import Media from './media';
import Richtext from './richtext';
import Link from './link';

export type ContentModalData = {
  text: Richtext;
  cta?: Link;
};

export class PdpValueTile {
  description?: string;
  id: string | undefined;
  icon?: Media;
  infoIcon?: Media;
  label?: string;
  modalContent?: ContentModalData;
  analyticsAttributes?: any;

  constructor(props: any) {
    if (!props) return;

    if (!props.label && !props.icon) return;

    this.description = props.description;
    this.id = props.sys?.id;
    this.icon = props.icon ? new Media(props.icon) : undefined;
    this.infoIcon = props.infoIcon ? new Media(props.infoIcon) : undefined;
    this.label = props.label;
    this.modalContent = props.modalContent
      ? {
          text: new Richtext(props.modalContent),
          cta: props.modalCta ? new Link(props.modalCta) : undefined
        }
      : undefined;
    this.analyticsAttributes = props.analyticsAttributes;
  }
}

export default PdpValueTile;
